import React from 'react';
import { string } from 'prop-types';

import {
  CardContainer,
  Header,
  Status,
  IconContainer,
  VerticalAlign,
  HeaderContainer,
  StatusContainer,
  StatusContent,
  Divider,
  InfoWrapper,
} from './load-status.style';
import { getActivityIcon } from '../../../../utils/mappers';
import InfoTooltipButton from '../info-tooltip-button/info-tooltip-button';
import { TOOLTIP_MESSAGES, MODE_TYPES } from '../../../../constants';
import ImageIcon from '../image-icon';

/**
 * The load status component
 * @param {object} props - Object containing the props for this component
 * @param {string} props.loadStatus - The current status of our load
 * @param {string} props.processStatus - The current process status of our load
 * @param {string} props.mode - The current mode type
 * @return {element}
 */
const LoadStatus = ({ mode, loadStatus, processStatus }) => (
  <CardContainer data-testid="load-status">
    <StatusContainer mode={mode}>
      <StatusContent>
        <IconContainer>
          <ImageIcon src={getActivityIcon(loadStatus)} altString="icon-indicator" width={40} height={40} />
        </IconContainer>
        <VerticalAlign>
          <HeaderContainer>
            <Header>{mode === MODE_TYPES.truckload ? 'Status' : 'Transit Status'}</Header>
          </HeaderContainer>
          <Status>{loadStatus}</Status>
        </VerticalAlign>
      </StatusContent>
      {mode === MODE_TYPES.lessThanTruckload && (
        <>
          <Divider />
          <StatusContent>
            <IconContainer>
              <ImageIcon src={getActivityIcon(processStatus)} altString="icon-indicator" width={40} height={40} />
            </IconContainer>
            <VerticalAlign>
              <HeaderContainer>
                <Header>Process Status</Header>
              </HeaderContainer>
              <Status>{processStatus}</Status>
            </VerticalAlign>
          </StatusContent>
        </>
      )}
      <InfoWrapper>
        <InfoTooltipButton text={TOOLTIP_MESSAGES['load-status']} />
      </InfoWrapper>
    </StatusContainer>
  </CardContainer>
);

LoadStatus.propTypes = {
  loadStatus: string,
  processStatus: string,
  mode: string.isRequired,
};

LoadStatus.defaultProps = {
  loadStatus: 'default',
  processStatus: undefined,
};

export default LoadStatus;
